import type { FragmentOf } from "@opensea/graphql"
import { graphql, readFragment } from "@opensea/graphql"
import { useEffect } from "react"
import { useTranslations } from "use-intl"
import { TransactionFullScreen } from "../../../../../components/TransactionFullScreen"
import { FlowActions } from "../../../../../stores/flowStore"

export const DropPublishStatusCollectionFragment = graphql(`
  fragment DropPublishStatusCollection on Collection {
    imageUrl
  }
`)

type Props = {
  collection: FragmentOf<typeof DropPublishStatusCollectionFragment>
  success: boolean
}

export function DropPublishStatus({
  collection: collectionKey,
  success,
}: Props) {
  const t = useTranslations("wallet.DropPublishStatus")
  const collection = readFragment(
    DropPublishStatusCollectionFragment,
    collectionKey,
  )

  useEffect(
    function handleSuccess() {
      if (success) {
        FlowActions.onSuccess()
      }
    },
    [success],
  )

  if (success) {
    return (
      <TransactionFullScreen
        body={t("success.description")}
        confetti
        images={[collection.imageUrl]}
        title={t("success.title")}
      />
    )
  }

  return (
    <TransactionFullScreen
      body={t("failed.description")}
      images={[collection.imageUrl]}
      monochrome
      title={t("failed.title")}
    />
  )
}
